export default __webpack_public_path__ + "static/media/abstract7.55432645.jpeg";